import { render, staticRenderFns } from "./yuerbbaozhuang.vue?vue&type=template&id=c81bd94e&scoped=true&"
import script from "./yuerbbaozhuang.vue?vue&type=script&lang=js&"
export * from "./yuerbbaozhuang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81bd94e",
  null
  
)

export default component.exports